import React, { useState } from 'react';
import { Box, Text, Table, Thead, Tbody, Tr, Th, Td, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { PageContainer } from '../../layouts/PageContainer';
import { PageHeader } from '../../layouts/PageHeader';
import { Link } from 'react-router-dom';

const ViewAllRequestsPage = () => {
    const [tableData, setTableData] = useState([
        { date: "02-04-2024", request_status: "Pending", sql: 'SELECT * FROM TABLE WHERE AGE > 2.5' },
        { date: "02-04-2024", request_status: "Approved", sql: 'SELECT * FROM TABLE WHERE YEAR = 2020' },
    ]);

    const cancelButtonColor = "#1C4342";
    const disabledButtonColor = "gray";
    const navigate = useNavigate();

    const handleCancel = (index) => {
        const updatedData = tableData.map((item, idx) => {
            if (idx === index) {
                return { ...item, request_status: "Cancelled" };
            }
            return item;
        });
        setTableData(updatedData);
    };

    const navigateToApprovedPage = (status) => {
        if (status === 'Approved') {
            navigate('/exchange_approved_request');
        }
    };

    return (
        <PageContainer>
            <PageHeader title="External Search" color="#1C4342"></PageHeader>
            <Box px={4} py={8}>
                <Text fontSize={"2.5rem"} color="#1C4342">
                    External Search
                </Text>
                <Text fontSize={"1.2rem"} color="#1C4342">
                    External Search Requests:
                </Text>
                <Text fontSize={"1.2rem"} color="#1C4342">
                    • Please be aware that once a request has been approved, the option to cancel it is no longer available.
                </Text>

                <Table variant="simple">
                    <Thead>
                        <Tr bg="#1C4342">
                            <Th color="white">Submit Date</Th>
                            <Th color="white">Request Status</Th>
                            <Th color="white">Cancel Status</Th>
                            <Th color="white">SQL Query/Specified Criteria</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {tableData.map((data, index) => (
                            <Tr key={index}>
                                <Td>{data.date}</Td>
                                <Td>
                                    <Text 
                                        cursor={data.request_status === "Approved" ? "pointer" : "default"} 
                                        color={cancelButtonColor}
                                        onClick={() => data.request_status === "Approved" && navigateToApprovedPage(data.request_status)}
                                    >
                                        {data.request_status}
                                    </Text>
                                </Td>
                                <Td>
                                    {data.request_status === "Pending" ? (
                                        <Button 
                                            bg={cancelButtonColor} 
                                            color="white" 
                                            onClick={() => handleCancel(index)}
                                        >
                                            Cancel
                                        </Button>
                                    ) : (
                                        <Button 
                                            bg={disabledButtonColor} 
                                            color="white" 
                                            isDisabled
                                        >
                                            Cancel
                                        </Button>
                                    )}
                                </Td>
                                <Td>{data.sql}</Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>

                <Box display="flex" mt={4}>
                    <Link to="/app/exchange">
                        <Button bg="#1C4342" color="white" mr={2}>
                            Back
                        </Button>
                    </Link>
                </Box>
            </Box>
        </PageContainer>
    );
};

export default ViewAllRequestsPage;
